import type { StatsConfig } from '@/components/composite/MediaViewer/components/MediaViewerStats/types';

import { avgEngagementRatePerPostConfig } from '@/lib/analytics/kpis/x/avgEngagementRatePerPost';
import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';

export const mediaViewerEngagementConfig: StatsConfig = {
    ...avgEngagementRatePerPostConfig,
    id: 'engagement_rate',
    type: 'kpi',
    size: SIZE_50,
    loader: MediaViewerKpiLoader
};
